import FileUploadIcon from "@mui/icons-material/FileUpload";
import { Box, IconButton, TextField } from "@mui/material";
import { CSSProperties, useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { RichText, RichTextKind } from "../../../../model/question/RichText";
import { selectEditMode } from "../../../../store/user/selector";
import { LogError } from "../../../../tools/log";
import { BBDialog } from "../../feedbacks/dialog/BBDialog";
import { CloseButton, SaveButton } from "./Buttons";
import { transHTMLText } from "./rich_text";

interface DivPureTextProps {
    text: string;
    onSave?: (t: string) => void;
    noSave?: boolean;
    style?: CSSProperties;
    onTransRich?: (rich: RichText) => void;
    containsRep?: boolean;
    saveRealTime?: boolean;
    center?: boolean;
}
export function DivPureText(props: DivPureTextProps) {
    const { text, onSave: saveText, style, onTransRich, containsRep, saveRealTime, center } = props;

    const editMode = useSelector(selectEditMode);
    return (
        <Box
            sx={{
                display: "flex",
                width: "100%",
                alignItems: "center",
                justifyContent: center ? "center" : undefined,
            }}
        >
            {editMode ? (
                <PureTextEdit
                    text={text}
                    onSave={saveText}
                    onTransRich={onTransRich}
                    containsRep={containsRep ? true : false}
                    saveRealTime={saveRealTime}
                />
            ) : (
                <PureTextDisplay text={text} style={style} />
            )}
        </Box>
    );
}

interface PureTextEditProps {
    text: string;
    onSave?: (t: string) => void;
    onTransRich?: (r: RichText) => void;
    containsRep: boolean;
    saveRealTime?: boolean;
}
function PureTextEdit(props: PureTextEditProps) {
    const { text, onSave, onTransRich, containsRep, saveRealTime } = props;
    const [draft, setDraft] = useState(text);

    useEffect(() => {
        setDraft(text);
    }, [text]);

    const value = saveRealTime ? text : draft;
    const handleChangeValue = saveRealTime
        ? (s: string) => {
              if (onSave) onSave(s);
          }
        : setDraft;

    const saveDiv = (
        <>
            {draft !== text && (
                <>
                    {onSave !== undefined && <SaveButton onClick={() => onSave(draft)} />}
                    <CloseButton onClick={() => setDraft(text)} />
                </>
            )}
        </>
    );
    return (
        <Box sx={{ width: "100%", display: "flex" }}>
            <TextField
                // label="text"
                size="small"
                fullWidth
                multiline
                value={draft}
                onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                    let val = event.target.value.replace(/\$\$\$/g, "\n");
                    // setDraft(val);
                    handleChangeValue(val);
                }}
            />
            {!saveRealTime && saveDiv}
            {onTransRich !== undefined && !containsRep && (
                <DivTransHTMLText text={text} onTransRich={onTransRich} />
            )}
        </Box>
    );
}

interface DivTransHTMLTextProps {
    text: string;
    onTransRich: (r: RichText) => void;
}

function DivTransHTMLText(props: DivTransHTMLTextProps) {
    const { text, onTransRich } = props;
    const [dialog, setDialog] = useState(false);
    return (
        <Box sx={{ display: "flex", minWidth: "50px" }}>
            <TransButton setDialog={setDialog} />
            <BBDialog
                title={"转富文本"}
                open={dialog}
                setOpen={setDialog}
                content={
                    <>
                        将纯文本升级为富文本，转换后
                        <br />
                        优点：
                        <ul>
                            <li>文本高亮</li>
                            <li>文本加粗</li>
                            <li>插入公式</li>
                            <li>插入图片</li>
                            <li>...</li>
                        </ul>
                        <br />
                        缺点：
                        <ul>
                            <li>不能直接打空格：需要用 {"&nbsp;"} 来表示空格</li>
                            <li>不能直接换行：需要用{"<br/>"}换行 </li>
                        </ul>
                        <br />
                        其他：
                        <ul>
                            <li>加粗：{"<b>内容<b/>"}表示加粗</li>
                        </ul>
                        <br />
                        转换
                        <span style={{ color: "red" }}>
                            <b>不可逆</b>
                        </span>
                        ，确认执行？
                    </>
                }
                onConfirm={() => {
                    const r2 = transHTMLText({
                        type: RichTextKind.PureText,
                        pure_text: text,
                    } as RichText);
                    onTransRich(r2);
                    setDialog(false);
                }}
            />
        </Box>
    );
}

interface PureTextDisplayProps {
    text: string;
    style?: CSSProperties;
}
export function PureTextDisplay(props: PureTextDisplayProps) {
    const { text, style: styleRef } = props;

    // copy from HTMLTextDisplay
    const [mathJaxRendered, setMathJaxRendered] = useState(false);
    useEffect(() => {
        setMathJaxRendered(false);
        const MathJax = (window as any).MathJax;
        if (MathJax && MathJax.typesetPromise) {
            window.MathJax.typesetClear();
            window.MathJax.typesetPromise()
                .then(() => {
                    // console.log("MathJax formulas have been re-rendered.");
                    setMathJaxRendered(true); // 更新状态为已渲染
                })
                .catch((err: any) => LogError("MathJax rendering error:", err));
        }
    }, [text]);

    return (
        <Box
            sx={{
                whiteSpace: "pre-wrap",
                ...styleRef,
            }}
        >
            {text}
        </Box>
    );
}

function TransButton(props: { setDialog: (b: boolean) => void }) {
    const { setDialog } = props;
    return (
        <IconButton
            onClick={() => {
                setDialog(true);
            }}
        >
            <FileUploadIcon />
        </IconButton>
    );
}
